import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import { getBaseUrl } from './utils/routing';
import { ThemeProvider } from './themes';
import 'virtual:kgp-theme.css';
import './styles/index.css';
import './styles/motion.css';
import { initMotion } from './lib/motion';

// Import StateExporter for development mode
if (import.meta.env.DEV) {
  // @ts-ignore - stateExporter is a JS file without type declarations
  import('./utils/stateExporter').then(() => {
    console.log('StateExporter loaded for development');
  });
}

// Matomo page analytics, live builds only (local previews and e2e runs are not counted).
if (import.meta.env.PROD && !['localhost', '127.0.0.1'].includes(location.hostname)) {
  import('./matomo');
}

// Before the first render, so `motion-ok` is on <html> before any content exists.
initMotion();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename={getBaseUrl()}>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
); 